module.exports = __webpack_public_path__ + "static/media/cogni_1.ad4563a9.jpeg";